<!-- 组件说明 -->
<template>
  <div>
    <div class="con shangxin" v-for="(item, index) in floorLists" :key="index">
      <div class="box_hd">
        <h1>{{ item.title }}</h1>
        <div class="moreBtn c-pointer" @click="toDetail(item.label)">
          更多<img :src="require('@/assets/images/icon_more.png')" alt="" />
        </div>
      </div>
      <div class="box_bd">
        <div class="col-390 c-pointer" v-if="item.ads[0]">
          <img
            v-lazy="item.ads[0].image"
            alt=""
            @click="indexgoto(item.ads[0])"
          />
        </div>
        <div class="col-800">
          <div class="col-800-top">
            <div class="top-item c-pointer" v-if="item.ads[1]">
              <img
                v-lazy="item.ads[1].image"
                alt=""
                @click="indexgoto(item.ads[1])"
              />
            </div>
            <div class="top-item c-pointer" v-if="item.ads[2]">
              <img
                v-lazy="item.ads[2].image"
                alt=""
                @click="indexgoto(item.ads[2])"
              />
            </div>
          </div>
          <div class="col-800-box">
            <div class="col-800-bottom" ref="itemBox">
              <div
                class="bottom-item c-pointer"
                v-for="(i, index) in item.goods"
                :key="index"
                @click="goto(i)"
              >
                <div class="col-192-img">
                  <img v-lazy="i.image ? i.image : $defaultImg" alt="" />
                </div>
                <a>{{ i.name }}</a>
                <div>
                  <span class="new-price" v-if="$store.state.hasLogin">
                    <span class="RMB">¥</span>{{ i.price }}</span
                  >
                  <!-- <span class="old-price">¥38.00</span> -->
                </div>
              </div>
            </div>
            <div class="preBtn c-pointer" @click="preItem(index)">
              <!-- <img :src="require('@/assets/images/commodity_left02.png')"  alt="" /> -->
              <img
                :src="require('@/assets/images/commodity_left.png')"
                alt=""
              />
            </div>
            <div class="nextBtn c-pointer" @click="nextItem(index)">
              <img
                :src="require('@/assets/images/commodity_right.png')"
                alt=""
              />
              <!-- <img :src="require('@/assets/images/commodity_right02.png')" alt="" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["floorLists"],
  components: {},
  data() {
    return {};
  },

  computed: {},
  methods: {
    indexgoto(item) {
      this.$emit("indexgoto", item);
    },
    goto(item) {
      this.$router.push({
        name: "detail",
        query: { goodsId: item.id, type: 1 },
      });
      this.ANALYSISSAVE(item);
    },
    toDetail(label) {
      this.$store.commit("GET_GOODSLIST", "");
      this.$router.push({ name: "search", query: { labels: label } });
    },
    preItem(index) {
      if (this.floorLists[index].goods.length > 4) {
        //console.log(index);
        var item = this.floorLists[index].goods.splice(-1, 1);
        this.floorLists[index].goods.unshift(...item);
      }
    },
    nextItem(index) {
      if (this.floorLists[index].goods.length > 4) {
        //console.log(index);
        var item = this.floorLists[index].goods.splice(0, 1);
        this.floorLists[index].goods.push(...item);
      }
    },
    ANALYSISSAVE(gooodsDetail) {
      let domain = "http://www.dgsjyyy.com";
      let source = "web";
      let goodId = gooodsDetail.id;
      let content = gooodsDetail.name;
      let goodsName = gooodsDetail.name;
      let title;
      let type;
      let url;
      title = "访问商品";
      (type = "detail"),
        (url = `http://www.dgsjyyy.com/detail?goodsId=${gooodsDetail.id}&type=1`);
      this.$api
        .POST_ANALYSISSAVE({
          domain,
          source,
          title,
          type,
          url,
          content,
          goodId,
          goodsName,
        })
        .then((res) => {
          //console.log(res);
        })
        .catch((err) => console.log(err));
    },
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss' scoped >
// 楼层模块
.shangxin {
  padding-top: 35px;
}
.box_hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  h1 {
    font-size: 28px;
    color: #333333;
    font-weight: 400;
  }
  .moreBtn {
    margin-left: 8px;
    font-size: 13px;
    color: #999999;
    img {
      padding-left: 6px;
    }
  }
}
.box_bd {
  display: flex;
  justify-content: space-between;
  .col-390 {
    width: 390px;
    height: 530px;
    background-color: #eeeeee;
    flex-shrink: 0;
    border-radius: 8px;
    overflow: hidden;
    img {
      @include size(100%, 100%);
    }
  }
  .col-800 {
    width: 800px;
    .col-800-top {
      display: flex;
      justify-content: space-between;
      .top-item {
        height: 260px;
        width: 395px;
        background-color: #eeeeee;
        border-radius: 8px;
        overflow: hidden;
        img {
          @include size(100%, 100%);
        }
      }
    }
    .col-800-box {
      position: relative;
      width: 800px;
      height: 270px;
      overflow: hidden;
      .preBtn {
        @include abs-y-c;
      }
      .nextBtn {
        @include abs-y-c;
        right: 0;
      }
    }
    .col-800-bottom {
      position: absolute;
      display: flex;
      margin-top: 10px;
      align-items: center;
      // justify-content: space-between;
      height: 260px;
      padding-bottom: 8px;
      padding-left: 7px;
      .bottom-item {
        // float: left;
        width: 190px;
        height: 100%;
        align-items: center;
        background-color: #ffffff;
        flex-shrink: 0;
        transition: box-shadow 0.2s;
        &:nth-child(n-1) {
          margin-right: 8px;
        }

        &:hover {
          box-shadow: 0 0 10px 1px#f0f0f0;
        }
        @include flex-d-c;
        .col-192-img {
          width: 150px;
          height: 150px;
          background-color: #eeeeee;
          margin-top: 16px;
          border-radius: 4px;
          overflow: hidden;
          img {
            @include size(100%, 100%);
          }
        }
        a {
          display: block;
          text-align: center;
          color: #505050;
          font-size: 13px;
          margin: 16px 20px 14px 20px;

          @include textLineClamp(2);
        }
        .RMB {
          font-size: 12px;
        }
        .new-price {
          color: #fa4b4b;
          font-weight: bold;
          font-size: 16px;
          margin-right: 8px;
        }
        .old-price {
          font-size: 13px;
          color: #999999;
          text-decoration: line-through;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/home/components/home-floor1.vue